/**
 * User utility functions for authentication and user management
 */

import StatsWrapper from "./StatsWrapper";

/**
 * Checks if a user is currently logged in
 * @returns {boolean} True if the user is logged in, false otherwise
 */
export const isLoggedIn = () => {
  // Check if either firstName or lastName cookie exists
  const firstName = getCookie('firstName');
  const lastName = getCookie('lastName');
  return !!(firstName || lastName);
};

/**
 * Logs out the current user by removing the token from localStorage
 */
export const logout = () => {

  // Call the logout API endpoint
  fetch('/api/user/logout', {
    method: 'POST',
    credentials: 'include' // Include cookies in the request
  })
  .then(() => {
    StatsWrapper.track('auth.logout.success');
    // reload the page
    window.location.reload();
  })
  .catch(error => {
    StatsWrapper.track('auth.logout.failed');
    console.error('Logout failed:', error);
  });
};

/**
 * Gets a cookie value by name
 * @param {string} name - The name of the cookie to retrieve
 * @returns {string|null} The cookie value or null if not found
 */
const getCookie = (name) => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
};

/**
 * Gets the user's first name from cookies
 * @returns {string} The user's first name or empty string if not found
 */
export const getFirstName = () => {
  return getCookie('firstName') || '';
};

/**
 * Gets the user's last name from cookies
 * @returns {string} The user's last name or empty string if not found
 */
export const getLastName = () => {
  return getCookie('lastName') || '';
};

/**
 * Gets the user's full name (first name + last name) from cookies
 * @returns {string} The user's full name or empty string if not found
 */
export const getFullName = () => {
  const firstName = getFirstName();
  const lastName = getLastName();
  
  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  } else if (firstName) {
    return firstName;
  } else if (lastName) {
    return lastName;
  }
  
  return '';
};
